import { ExcelTable } from "../views/ExcelTable/ExcelTable";
import { FormGeneratorView } from "../views/form-generator/FormGeneratorView";

import Receipt from "@material-ui/icons/Receipt";

export const devRoutes = [
  {
    collapse: true,
    name: "Z-Devs",
    icon: Receipt,
    state: "devsCollapse",
    inSidebar: true,
    isProtected: true,
    rule: "DEVELOPER",
    views: [
      {
        path: "/EXPERIMENTS",
        name: "AutoTable",
        mini: "AT",
        component: ExcelTable,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: "DEVELOPER",
      },
      {
        path: "/form-generator",
        name: "Form Generator",
        mini: "FG",
        component: FormGeneratorView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: "DEVELOPER",
      },
    ],
  },
]